export enum WarOfBetsCardType {
    PLAYER = 'player',
    DEALER = 'dealer',
    WAR = 'war',
}
